<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('holidays')" :icon="'grid'" />
            </div>
            <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_holidays')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <holiday-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="holiday-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { formatDateToLocal } from '../../../Helpers/Helpers';
import { status } from '../../../Mixins/FilterMixin';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppHolidays",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'holidays-table',
            rowData: {},
            options: {
                name: 'AppHolidays',
                url: actions.HOLIDAY,
                showHeader: true,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                    },
                    {
                        title: this.$t('date'),
                        type: 'object',
                        key: 'date',
                        modifier: (date => formatDateToLocal(date))
                    },
                    {
                        title: this.$t('description'),
                        type: 'text',
                        key: 'description',
                    },

                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'holiday-add-modal',
                        modalId: 'holiday-add-edit-modal',
                        modifier: () => this.$can('update_holidays'),

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: () => this.$can('delete_holidays'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#holiday-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.HOLIDAY}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.HOLIDAY}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#holiday-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
